import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Form,
  Alert,
  Image,
} from "react-bootstrap";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import classes from "./login.module.css";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import Modallog from "./Modal/Modal";
import Backdroplog from "./Backdrop/Backdrop";
import * as actionTypes from "../../Action/Index";
import Spinner from "react-bootstrap/Spinner";
import * as validations from "../../validations/validations";
import logo from "../../Assets/Images/LogoColored.png";
import IVerifyMobile from "../OtpModal/OTP/VerifyMobile";
import NewSweetAlert from "react-bootstrap-sweetalert";
class Login extends Component {
  state = {
    forgotModal: false,
    fs: true,
    loader: false,
    loginStatus: false,
    type: "password",
    readOnly: "true",
    show: false,
    interviewer: false,
    candidate: true,
    emUsernameErrorMsg: "",
    inUsernameErrorMsg: "",
    empasswordErrorMsg: "",
    inpasswordErrorMsg: "",
    OtpModal: false,
    email: "abc@innovationm.com",
    emailCode: false,
  };

  modalHandler = () => {
    this.setState({
      fs: false,
    });
  };
  modalShow = () => {
    this.setState({
      forgotModal: true,
    });
    document.getElementById("_password").value = "";
  };

  modalClosed = () => {
    this.setState({
      fs: true,
      forgotModal: false,
    });
  };

  loginHandler = (e) => {
    this.setState({
      show: false,
    });
    e.preventDefault();

    if (e.target.email.value === "") {
      this.setState({
        emUsernameErrorMsg: "Enter your Email ID",
        empasswordErrorMsg: "",
        inUsernameErrorMsg: "",
        inpasswordErrorMsg: "",
      });
    } else if (
      !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        e.target.email.value.trim()
      )
    ) {
      this.setState({
        emUsernameErrorMsg: "Please enter a valid Email ID",
        empasswordErrorMsg: "",
        inUsernameErrorMsg: "",
        inpasswordErrorMsg: "",
      });
    } else if (e.target.password.value === "") {
      this.setState({
        empasswordErrorMsg: "Enter your Password",
        emUsernameErrorMsg: "",
        inUsernameErrorMsg: "",
        inpasswordErrorMsg: "",
      });
    } else if (!/^.{8,16}$/.test(e.target.password.value)) {
      this.setState({
        empasswordErrorMsg: "Password length 8-15",
        emUsernameErrorMsg: "",
        inUsernameErrorMsg: "",
        inpasswordErrorMsg: "",
      });
    } else {
      // const username = "em" + e.target.email.value.trim()
      this.setState({ email: e.target.email.value.trim() });
      const password = e.target.password.value;
      this.props.onSubmit(e.target.email.value.trim(), password);
    }
  };

  componentDidUpdate(prevProps) {
    if (this.props.loginStatus === true) {
      this.props.history.push("/interview");
    } else if (
      this.props.initial !== true &&
      prevProps.initial !== this.props.initial
    ) {
      this.setState({
        show: true,
      });
    }
    if (this.props.errorMsg !== prevProps.errorMsg) {
      if (this.props.errorMsg) {
        this.setState({
          errorMsg: this.props.errorMsg,
        });
      }
    }
  }

  passwordFormatChangedHandler = () => {
    if (this.state.type === "password") {
      this.setState({
        type: "text",
      });

      document.getElementById("password").classList.add("fa-eye");
      document.getElementById("password").classList.remove("fa-eye-slash");
    } else {
      this.setState({
        type: "password",
      });
      document.getElementById("password").classList.remove("fa-eye");
      document.getElementById("password").classList.add("fa-eye-slash");
    }
  };
  setShow() {
    this.setState({
      show: false,
    });
  }

  passwordLength = (e, len2) => {
    if (e.target.value.length >= len2 && e.which !== 8) {
      e.preventDefault();
    }
  };

  closeModalVerify = () => {
    this.setState({ OtpModal: false });
    this.props.clearLoginState();
  };

  hideAlert = () => {
    this.setState({ emailCode: false });
    this.props.clearLoginState();
  };

  gotoHome = () => {
    window.open("https://www.foxmatrix.com/");
  };

  render() {
    //alert(this.state.show);
    return (
      <div className={classes.Background}>
        <Container fluid>
          <Row>
            <Col md={6} xs={12} sm={12}></Col>
            <Col md={6} xs={12} sm={12} style={{ marginTop: "5%" }}>
              <Card style={{ width: "32em", paddingBottom: "5%" }}>
                <Card.Body>
                  <Card.Title
                    className="text-center"
                    style={{ color: "#52aa9d", paddingTop: "25px" }}
                  >
                    <Image
                      width="200px"
                      src={logo}
                      alt="Logo"
                      fluid
                      onClick={this.gotoHome}
                      style={{ cursor: "pointer" }}
                    />
                    {/* <h5 style={{color:"#000",marginTop:"13px"}}>Self Assessment</h5>      */}
                  </Card.Title>

                  {/* {this.state.show ? (
                    <div className={classes.alerMainBox}>
                      <div className={classes.alert}>
                        <p
                          className={classes.closebtn}
                          onClick={() => this.setShow()}
                        >
                          &times;
                        </p>
                      </div>
                      <div className={classes.messageBox}>
                        {this.props.errorMsg}
                      </div>
                    </div>
                  ) : null} */}
                  {this.state.show && this.state.errorMsg ? (
                    <div className={classes.alerMainBox}>
                      <div className={classes.alert}>
                        <p
                          className={classes.closebtn}
                          onClick={() => this.setShow()}
                        >
                          &times;
                        </p>
                      </div>
                      <div className={classes.messageBox}>
                        {this.state.errorMsg}
                      </div>
                    </div>
                  ) : null}

                  <Form
                    style={{ padding: "0px 24px" }}
                    onSubmit={(e) => this.loginHandler(e)}
                    id="employerForm"
                  >
                    <div className="container my-5">
                      <div className="row">
                        <div style={{ width: "100%" }}>
                          <label className="has-float-label">
                            <input
                              type="text"
                              placeholder=" "
                              name="email"
                              ref={(element) => (this.email = element)}
                              //   autocomplete="off" readonly

                              autoComplete="off"
                              height="1px"
                              onClick={() => this.setState({ readOnly: false })}
                              readOnly={this.state.readOnly}
                              maxLength="52"
                              onInput={() => {
                                this.setState({ emUsernameErrorMsg: "" });
                              }}
                              onFocus={() => {
                                this.setState({
                                  empasswordErrorMsg: "",
                                  inUsernameErrorMsg: "",
                                  inpasswordErrorMsg: "",
                                });
                              }}
                            />
                            <span>Email ID</span>
                          </label>
                          <span className={classes.UsernameValidation}>
                            &nbsp;{this.state.emUsernameErrorMsg}
                          </span>
                        </div>
                      </div>
                    </div>
                    <Row style={{ marginTop: "-42px" }}>
                      <Col>
                        <label className="has-float-label">
                          <input
                            type={this.state.type}
                            id="_password"
                            placeholder=" "
                            autoComplete="off"
                            name="password"
                            ref={(element) => (this.pass = element)}
                            onInput={() => {
                              this.setState({ empasswordErrorMsg: "" });
                            }}
                            onFocus={() => {
                              this.setState({
                                emUsernameErrorMsg: "",
                                inUsernameErrorMsg: "",
                                inpasswordErrorMsg: "",
                              });
                            }}
                            onKeyDown={(e) => this.passwordLength(e, 15)}
                          />
                          <span>Password</span>
                        </label>
                        <span className={classes.PasswordValidation}>
                          &nbsp;{this.state.empasswordErrorMsg}
                        </span>
                        <span
                          toggle="#password-field"
                          className={`fa fa-fw fa-eye-slash ${classes.fieldIcon} toggle-password`}
                          id="password"
                          onClick={this.passwordFormatChangedHandler}
                        ></span>
                      </Col>
                    </Row>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginBottom: "25px",
                      }}
                    >
                      <div
                        onClick={this.modalShow}
                        style={{
                          cursor: "pointer",
                          color: "#fbb03b",
                          fontWeight: "bold",
                        }}
                      >
                        Forgot password?
                      </div>
                    </div>

                    <div
                      className="text-center"
                      style={{ fontWeight: "500 !important" }}
                    >
                      <Button
                        className={`text-center mt-3 ${classes.Button}`}
                        type="submit"
                        variant="warning"
                      >
                        Login
                      </Button>
                      {this.props.loader ? (
                        <div style={{ margin: "-35px 0px 0px 252px" }}>
                          <Spinner
                            animation="border"
                            variant="warning"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </Spinner>
                        </div>
                      ) : (
                        ""
                      )}
                      <div style={{ marginTop: "15px", display: "block" }}>
                        <span style={{ fontSize: "12px", color: "grey" }}>
                          Don't have an account?{" "}
                        </span>
                        <NavLink to="../signup">
                          <span
                            style={{ color: "#fbb03b", fontWeight: "bold" }}
                          >
                            {" "}
                            Sign Up
                          </span>
                        </NavLink>
                      </div>
                    </div>
                  </Form>
                  <Modallog
                    closedModal={this.modalClosed}
                    show={this.state.forgotModal}
                    type={this.state.candidate}
                    fs={this.state.fs}
                    modalHandler={this.modalHandler}
                  />
                  <Backdroplog show={this.state.forgotModal} />
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

// const mapStateToProps = (state) => {
//   console.log(
//     { state, errorMsg: state.employeeReducer.loginErrorMsg },
//     "error"
//   );
//   return {
//     loginStatus: state.employeeReducer.loginStatus,
//     errorMsg: state.employeeReducer.loginErrorMsg,
//     loader: state.employeeReducer.loader,
//     initial: state.employeeReducer.initial,
//     ErrorCode: state.employeeReducer.ErrorCode,
//     resendInterviewerEmailStatus:
//       state.employeeReducer.resendInterviewerEmailStatus,
//     resendInterviewerEmailLoader:
//       state.employeeReducer.resendInterviewerEmailLoader,
//   };
// };
const mapStateToProps = (state) => {
  console.log(state, "paras");
  return {
    loginStatus: state.employeeReducer.loginStatus,
    errorMsg: state.employeeReducer.loginErrorMsg,
    loader: state.employeeReducer.loader,
    initial: state.employeeReducer.initial,
    ErrorCode: state.employeeReducer.ErrorCode,
    resendInterviewerEmailStatus:
      state.employeeReducer.resendInterviewerEmailStatus,
    resendInterviewerEmailLoader:
      state.employeeReducer.resendInterviewerEmailLoader,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    onSubmit: (email, password) =>
      dispatch(actionTypes.getLogin(email, password)),
    clearLoginState: () => dispatch(actionTypes.clearLoginState()),
    resendInterviewerEmail: (email) =>
      dispatch(actionTypes.resendInterviewerEmail(email)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Login);
